import React, { Fragment } from "react";
import Dialog from "../../Dialog/Dialog";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import "./Style.css";

type Props = {
  children: React.ReactNode;
};

const Layout = (props: Props) => {
  return (
    <Fragment>
      <Header title="In Bitcoin Terms" />
      <main id="main-content" className="page-main">
        {props.children}
      </main>
      <br />
      <Footer />
      <Dialog />
    </Fragment>
  );
};

export default Layout;
